import { connect } from "react-redux";
import React, { useEffect, useState } from "react";

import { getQueryParams } from "@/utils/filters";
import { sharedRequests } from "@/api/(requests)/shared";
import { toastMessageTypes } from "@/redux/actions/toaster";

import PostSessionSurvey from "./components/PostSessionSurveyContainer";

const PostSessionSurveyWrapper = (props) => {
  const [questionSet, setQuestionSet] = useState(undefined);
  const { history, location } = props;
  const callId = getQueryParams("callId", location.search);

  useEffect(() => {
    (async () => {
      const question_set = await sharedRequests.get_post_session_survey_question_set({
        callId,
        context: {
          exceptionConfig: {
            MultipleSubmissionException: {
              errorCallback: () => history.push("/app/home"),
              toastErrorType: toastMessageTypes.warning,
            },
          },
        },
      });

      setQuestionSet(question_set);
    })();
  }, [callId, history]);

  if (!questionSet) {
    return <></>;
  }

  return <PostSessionSurvey {...props} callId={callId} questionSet={questionSet[0]} />;
};

const mapStateToProps = (state) => {
  return {
    authRedirectPath: state.auth.authRedirectPath,
  };
};

export default connect(mapStateToProps, {})(PostSessionSurveyWrapper);
